import { getDynamicData } from '@avensia/excite';
import * as React from 'react';
import { WishlistUpdateCommand, wishlistUpdateEvent } from '@avensia/excite-commercetools';
import { addToDataLayer, type DataLayerEvent, type EcommerceAdditionAttributes } from '..';
import { cartToDataLayerInfo, convertProductToGA4 } from '../utils';

export function useWishlistTracking() {
  React.useEffect(
    () =>
      wishlistUpdateEvent.on(async event => {
        // TODO need to find more efficient way to track wishlist updates
        const wishlist = await getDynamicData<NordicNest.Api.FullWishListApiModel>().refresh();
        if (event.command === WishlistUpdateCommand.Add) {
          const product = wishlist?.items.find(t => t.code === event.requestData.sku)?.trackingProductInformation;
          if (product) {
            const ga4Event: DataLayerEvent = {
              event: 'add_to_wishlist',
              ecommerce: {
                ...((event.commandEventData?.additionalProductAttributes as EcommerceAdditionAttributes)?.ecommerce ??
                  {}),
                ...(await cartToDataLayerInfo()),
                items: [
                  {
                    ...convertProductToGA4(product),
                    quantity: 1,
                  },
                ],
              },
            };
            addToDataLayer(ga4Event);
          }
        }

        // TODO fix wishlist tracking when we have time
        if (event.command === WishlistUpdateCommand.Remove) {
          const product = wishlist?.items?.find(x => x.code === event.requestData.sku)?.trackingProductInformation;

          if (product) {
            const ga4Event: DataLayerEvent = {
              event: 'remove_from_wishlist',
              event_info: {
                item_id: product.id,
              },
              ecommerce: {
                ...((event.commandEventData?.additionalProductAttributes as EcommerceAdditionAttributes)?.ecommerce ??
                  {}),
                ...(await cartToDataLayerInfo()),
              },
            };
            addToDataLayer(ga4Event);
          }
        }
      }),
    [],
  );
}
